import React, { useState } from "react";
import axios from "axios";
import { useUserContext } from "../../../contexts/UserContext";

export default function ChargeExtendModal({ open, charge, onClose, onExtended }) {
  const { getAuthHeaders } = useUserContext();
  const [months, setMonths] = useState(1);

  if (!open || !charge) return null;

  const handleExtend = async () => {
    const res = await axios.patch(
      `http://localhost:4000/charges/${charge._id}/extend`,
      { months },
      { headers: getAuthHeaders() }
    );

    onExtended();
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <h3>⏳ Prolonger la charge</h3>

        <p>
          <strong>{charge.description}</strong>
        </p>

        <label>Nombre de mois à ajouter</label>
        <input
          type="number"
          min="1"
          value={months}
          onChange={(e) => setMonths(e.target.value)}
        />

        <div className="modal-actions">
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-primary" onClick={handleExtend}>
            Prolonger
          </button>
        </div>
      </div>
    </div>
  );
}